import React, { Component } from 'react';
import animator from '../../helpers/animator';

var realStyle = function(_elem) {
  var computedStyle;
  if (typeof _elem.currentStyle != 'undefined') {
    computedStyle = _elem.currentStyle;
  } else {
    computedStyle = document.defaultView.getComputedStyle(_elem, null);
  }

  return computedStyle;
};

var copyComputedStyle = function(src, dest) {
  var s = realStyle(src);
  for (var key in s) {
    if (parseInt(key, 10) >= 0) {
      continue;
    }
    // Do not use `hasOwnProperty`, nothing will get copied
    if (typeof key == 'string' && key != 'id' && key != 'key' && key != 'cssText' && !/\d/.test(key) && s[key] != '' && dest.style[key] == '') {
      // The try is for setter only properties
      try {
        dest.style[key] = s[key];
        // `fontSize` comes before `font` If `font` is empty, `fontSize` gets
        // overwritten.  So make sure to reset this property. (hackyhackhack)
        // Other properties may need similar treatment
        if (key == 'font') {
          dest.style.fontSize = s.fontSize;
        }
      } catch (e) { }
    }
  }
  if (src.childElementCount > 0) {
    for (let j = 0; j < src.childElementCount; j++) {
      copyComputedStyle(src.children[j], dest.children[j]);
    }
  }
};

class Animate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      animating: false,
    };

    this.animator = new animator();

  }

  componentDidMount() {
    const { component_id, completionCallback, onUnmount } = this.props;
    this.setupAnimation(component_id);
    if (this.animator.hasAnimations && !onUnmount) {
      this.animator.processAnimationQueue(() => {
        if (completionCallback) {
          completionCallback();
        }
      });
    }
  }

  setupAnimation(id) {
    const { property, duration, geometry, collection } = this.props;
    if (collection) {
      
    }
    else {
      const ani = this.animator.createPropertyAnimation(id, duration, property, geometry);
      this.animator.addAnimation(ani);
    }
  }

  componentWillUnmount() {
    const { component_id, completionCallback, onUnmount } = this.props;

    if (this.animator.hasAnimations && onUnmount && !this.animated) {
      this.animated = true;

      // Pull it out of its parent and put it in the body.

      let clonedElementArray = [];
      const bodyElement = document.body;
      const element = document.getElementById(component_id);
      const elementRect = element.getBoundingClientRect();
      const clonedElement = element.cloneNode(true);
      let top = elementRect.top;
      let left = elementRect.left;

      clonedElement.style.top = top + 'px';
      clonedElement.style.left = left + 'px';
      const zIndex = element.style.zIndex ? parseInt(element.style.zIndex, 10) + 10 : 20;
      clonedElement.style.zIndex = zIndex;
      
      bodyElement.appendChild(clonedElement);

      // copyComputedStyle(element, clonedElement)
      clonedElementArray.push(clonedElement);
      clonedElement.setAttribute('id',  component_id + '_clone');

      this.setupAnimation(component_id + '_clone');

      this.animator.processAnimationQueue(() => {
        for (let i = 0; i < clonedElementArray.length; i++) {
          bodyElement.removeChild(clonedElementArray[i]);
        }
        if (completionCallback) {
          completionCallback();
        }
      });
    }
  }

  render() {
    return (
      <div />
    );
  }
}

export default (Animate);



// WEBPACK FOOTER //
// ./src/components/Animate/index.js